import React from 'react';

const LineProgressBar =({indexProgress =0}) =>{
    var width = 33.33 * indexProgress;
    const styleCss = {
        background: `linear-gradient(90deg,#008964 0%,#008964 ${width}%,#E5E4E4 ${width}%,#E5E4E4 100%)`
    }
    
    return (
        <div className="status-bar" style={styleCss} />
    );
}

export {LineProgressBar};